import css from './intro.module.scss';
import {Onboard} from '../../components/onboard/onboard';
import {Button} from '../../components/button/button';
import {Pagination} from '../../components/pagination/pagination';
import {CSSProperties, useState} from 'react';
import {INTRO_CONTENT} from './intro.mock';
import {normalizeContent} from './intro.helper';
import {useNavigate} from '@tanstack/react-location';
import {isMobile} from 'react-device-detect';
import {frameDimensions} from '../../shared/frame-dimensions';

const normalizedContent = normalizeContent(INTRO_CONTENT);

export const Intro = (): JSX.Element => {
	const [imageHeight, setImageHeight] = useState<number>(0);
	const [selected, setSelected] = useState<number>(1);
	const navigate = useNavigate();

	const onHeightSet = (onboardHeight: number) => {
		const margin = 80;
		const innerHeight = isMobile ? window.innerHeight : frameDimensions.height;
		setImageHeight(innerHeight - onboardHeight + margin);
	};

	const onClick = () => {
		if (selected === normalizedContent.length) {
			navigate({to: '/events'});
			return;
		}
		setSelected(selected + 1);
	};

	const imageStyles: CSSProperties = {
		height: imageHeight,
		backgroundImage: `url(${normalizedContent[selected - 1].background})`,
	};

	const setButton = () => {
		if (selected === normalizedContent.length) {
			return <Button onClick={onClick} name="Share Location" icon="/img/locationWhiteIco.svg" color="blue" />;
		}
		return <Button onClick={onClick} name="Next" color="blue" />;
	};

	return (
		<div className={css.container}>
			<div className={css.imageContainer} style={imageStyles} />
			<Onboard onHeightSet={onHeightSet}>
				<div className={css.contentContainer}>
					<div className={css.content}>
						<h3 className={css.head}>{normalizedContent[selected - 1].head}</h3>
						<p className={css.body}>{normalizedContent[selected - 1].desc}</p>
					</div>
					<div className={css.paginationContainer}>
						<Pagination length={normalizedContent.length} selected={selected} />
					</div>
					{setButton()}
				</div>
			</Onboard>
		</div>
	);
};
